<template>
  <router-link :to="to" type="button" :class="buttonClass">
    <slot></slot>
    <unicon
      v-if="withArrow"
      name="arrow-right"
      width="40"
      height="40"
      class="scroller__arrow"
    ></unicon>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: '',
    },
    withArrow: {
      type: Boolean,
      default: false
    },
    isWhiteMode: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.isWhiteMode) {
      this.className += " button--withWhiteBg";
    }
  },
  computed: {
    buttonClass() {
      return this.className ? `button ${this.className}` : 'button';
    }
  }
};
</script>